import {AfterViewInit, ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import { ErisFormFieldType } from 'eris-forms';

// copied eris-form checkbox and added [checked]="field.formControl.value", remove it when the 
// bug is fixed in eris-form
@Component({
    selector: 'lib-edit-anchor',
    template: `
        <br><br><div><h3>
            <a href="inspections/abroadCGMP/edit/{{field.templateOptions?.inspectionType}}/{{this.model.facility?.inspectionID}}/true">Edit</a>
        </h3></div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditAnchorComponent extends ErisFormFieldType{

    get type(): string {
        return this.to.type || 'edit-anchor';
    }
}
